import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { ComplianceType } from '../quality-check-scheme-detail/constants'

interface ComplianceRule {
  '规则ID': number;
  '规则描述': string;
  '违规项描述': Array<{ '描述': string }>;
  '豁免项描述': Array<{ '描述': string }>;
}

export const generateComplianceRules = (selectedCheckPlan: { detail?: AIQualityCheckPlanDetailItem }) => {
  if (!selectedCheckPlan.detail) {
    return {}
  }

  const detail = selectedCheckPlan.detail
  const ruleObject = {
    '方案ID': detail.id,
    '方案名称': detail.name,
    '各项规则': [] as ComplianceRule[],
  }

  if (detail.items) {
    detail.items.forEach((item, index) => {
      const ruleItem: ComplianceRule = {
        '规则ID': index + 1,
        '规则描述': item.name || '',
        '违规项描述': [] as Array<{ '描述': string }>,
        '豁免项描述': [] as Array<{ '描述': string }>,
      }

      if (item.subItems) {
        item.subItems.forEach(subItem => {
          if (subItem.complianceType === ComplianceType.violation) {
            ruleItem['违规项描述'].push({ '描述': subItem.description || '' })
          } else if (subItem.complianceType === ComplianceType.exemption) {
            ruleItem['豁免项描述'].push({ '描述': subItem.description || '' })
          }
        })
      }

      ruleObject['各项规则'].push(ruleItem)
    })
  }

  return ruleObject
}

export const generateMocRules = (selectedCheckPlan: { detail?: AIQualityCheckPlanDetailItem }) => {
  if (!selectedCheckPlan.detail) {
    return {}
  }

  const detail = selectedCheckPlan.detail
  const moduleMap = new Map()

  if (detail.items) {
    detail.items.forEach((item, index) => {
      const moduleName = item.moduleName || ''
      if (!moduleMap.has(moduleName)) {
        moduleMap.set(moduleName, {
          '模块名称': moduleName,
          '打分项': [],
        })
      }

      const scoringItem = {
        '打分项id': index + 1,
        '打分项名称': item.name || '',
        '打分项描述': item.description || '',
        '满分': item.scoreRangeMax,
        '打分细项': [],
      }

      if (item.subItems) {
        item.subItems.forEach(subItem => {
          const scoreDescription = subItem.scoreRangeMin === subItem.scoreRangeMax
            ? `${subItem?.scoreRangeMin || 0}分，${subItem?.description || ''}`
            : `${subItem?.scoreRangeMin || 0}-${subItem?.scoreRangeMax || 0}分，${subItem?.description || ''}`
          scoringItem['打分细项'].push({
            '描述': scoreDescription,
          })
        })
      }

      moduleMap.get(moduleName)['打分项'].push(scoringItem)
    })
  }

  return {
    '方案ID': detail.id,
    '方案名称': detail.name,
    '模块': Array.from(moduleMap.values()),
  }
}

export const generateScenarioTagRule = (selectedCheckPlan: { detail?: AIQualityCheckPlanDetailItem }) => {
  if (!selectedCheckPlan.detail) {
    return {}
  }

  const detail = selectedCheckPlan.detail
  const modules = []

  if (detail.items) {
    detail.items.forEach(item => {
      const moduleName = item.moduleName || ''
      const module = {
        '模块名称': moduleName,
        '模块标签': [
          {
            '标签名称': item.name || '',
            '标签描述': item.description || '',
          },
        ],
      }
      modules.push(module)
    })
  }

  return {
    '方案ID': detail.id,
    '方案名称': detail.name,
    '各模块': modules,
  }
}
